import { FormattedMessage } from 'react-intl'

import { type DiscountTableData } from '../models/types'

export const HowItWorksDiscountTableData: DiscountTableData[] = [
  {
    key: 'row-0',
    row1: (
      <FormattedMessage id="prescriptionBonus.modal.howItWorks.discount.table.row.0.0" />
    ),
    row2: (
      <FormattedMessage id="prescriptionBonus.modal.howItWorks.discount.table.row.0.1" />
    ),
  },
  {
    key: 'row-1',
    row1: (
      <FormattedMessage id="prescriptionBonus.modal.howItWorks.discount.table.row.1.0" />
    ),
    row2: (
      <FormattedMessage id="prescriptionBonus.modal.howItWorks.discount.table.row.1.1" />
    ),
  },
  {
    key: 'row-2',
    row1: (
      <FormattedMessage id="prescriptionBonus.modal.howItWorks.discount.table.row.2.0" />
    ),
    row2: (
      <FormattedMessage id="prescriptionBonus.modal.howItWorks.discount.table.row.2.1" />
    ),
  },
  {
    key: 'row-3',
    row1: (
      <FormattedMessage id="prescriptionBonus.modal.howItWorks.discount.table.row.3.0" />
    ),
    row2: (
      <FormattedMessage id="prescriptionBonus.modal.howItWorks.discount.table.row.3.1" />
    ),
  },
]
